const pages = {
  signIn: 'signIn',
  signUp: 'signUp',
  forgotPassword: 'forgotPassword',
  confirmAccount: 'confirmAccount'
}

export default pages